export const environment = {
  production: false,
  G_SAAS_GIGWORKER_URL : '/auth',
  G_SASS_GIG_WORKER_SIGNIN_URL:'sign-in',
  G_SASS_GIG_WORKER_SIGNUP_URL: 'sign-up',
  name: "dev"
};